export default function injectInitialState(state) {
  const script = document.createElement(`script`)
  const statePrerender = { ...state }
  // drop news store content
  statePrerender.news = {
    search: {
      magazines: false,
      socials: false,
    },
    news: {
      magazines: [],
      socials: [],
    },
    statistics: {
      magazines: [],
      socials: [],
    },
    statisticsMentions: {
      magazines: [],
      socials: [],
    },
    average: {
      magazines: 0.5,
      socials: 0.5,
    },
  }
  script.innerHTML = `window.__INITIAL_STATE__ = ${JSON.stringify(
    statePrerender
  )}`
  document.head.appendChild(script)
}
